// The bars of a ticket's screen recording and screen share (60.11.579), one above the other at the foot of every page of
// the panel, so both go on while the customer moves between pages. Since 60.11.580 they also show - after a refresh too -
// what the capture window holds.
import {FC, useEffect} from 'react'
import {mirrorCaptures} from './capture-hub'
import {ScreenRecordingHost} from './ScreenRecordingHost'
import {ScreenShareHost} from './ScreenShareHost'
import './screen-share.css'

export const ScreenCaptureDock: FC = () => {
  useEffect(() => mirrorCaptures(), [])
  return (
    <div className='mp-capture-dock'>
      <ScreenRecordingHost />
      <ScreenShareHost />
    </div>
  )
}
